import { render } from "./EditEventButton.vue?vue&type=template&id=0d0f2ff9"
import script from "./EditEventButton.vue?vue&type=script&lang=js"
export * from "./EditEventButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__